import { render } from "./AboutConnectionSection.vue?vue&type=template&id=267d3d00"
import script from "./AboutConnectionSection.vue?vue&type=script&lang=js"
export * from "./AboutConnectionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__